import { useEffect, useState } from "react";
import "./DealImage.css";

// Full URL of an uploaded file (handles spaces / special characters in the name)
export const uploadUrl = (file) =>
  file ? `${process.env.REACT_APP_API}uploads/${encodeURIComponent(file)}` : "";

// Shows the image. If it is missing or fails to load, shows a clean placeholder
// (or nothing when hideOnError is true, which is useful for small logos).
const DealImage = ({ file, alt = "", className = "", style, hideOnError = false }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [file]);

  if (!file || failed) {
    if (hideOnError) return null;
    return (
      <div
        className={`deal-img-fallback ${className}`}
        style={style}
        role="img"
        aria-label={alt || "Image not available"}
      >
        <i className="las la-image" aria-hidden="true" />
        <span>Image not available</span>
      </div>
    );
  }

  return (
    <img
      src={uploadUrl(file)}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
};

export default DealImage;